import PropTypes from 'prop-types';
import { useState } from 'react';
import { formatPhoneNumber, isValidationBasedOnType } from '../../utils/common';
import { VALID_EMAIL, VALID_PHONE_NUMBER, VALID_TEXT } from '../../utils/constant';


const TextForm = ({ element, handleChange }) => {
  const [showError, setShowError] = useState('');
  const [previousValue, setPreviousValue] = useState('');

  const handleClick = (event) => {
    const { value } = event.target;
    let tmpValue = formatPhoneNumber(value);
    if (tmpValue.length > 14) {
      tmpValue = formatPhoneNumber(value.substr(value.length - 10));
    }

    let userInput = value;
    if (element?.validationType === 'phone') {
      userInput = value.replace(/\D/g, '');
      if (userInput.length <= 10) {
        userInput = formatPhoneNumber(userInput);
      }
      setPreviousValue(userInput);
    }
    const question = { ...element, userInput, eligibleErr: true };
    if (question.isEligibal) {
      const eligVal = question.eligibleValues.split(',');
      if (eligVal?.includes(question.userInput)) {
        question.eligibleErr = false;
      }
    }
    if (question.isRequired) {
      if (question?.validationType === 'email') {
        if (isValidationBasedOnType(question?.userInput, 'email')) {
          setShowError('');
          question.validationError = false;
        } else {
          setShowError(VALID_EMAIL);
          question.validationError = true;
        }
      } else if (element?.validationType === 'phone') {
        if (isValidationBasedOnType(question?.userInput, 'phone')) {
          setShowError('');
          question.validationError = false;
        } else {
          setShowError(VALID_PHONE_NUMBER);
          question.validationError = true;
        }
      } else if (isValidationBasedOnType(question?.userInput, question?.validationType)) {
        setShowError('');
        question.validationError = false;
      } else {
        setShowError(VALID_TEXT);
        question.validationError = true;
      }
    } else {
      setShowError('');
      question.validationError = false;
    }
    handleChange(event, question);
  };

  return (
    <>
      <div className="w-100">
        <input
          type="text"
          className="form-control fs-13 answer inputText"
          placeholder={element?.placeholder}
          maxLength={element?.validationType === 'phone' ? 14 : ''}
          value={element?.validationType === 'phone' ? previousValue : element?.userInput}
          name={element?.question}
          onChange={handleClick}
        />
      </div>
      <span className="text-danger fs-12">{showError !== '' && showError}</span>
    </>
  );
};

TextForm.propTypes = {
  element: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
};
export default TextForm;
